import gql from 'graphql-tag';

export default gql`
  query lookupRegistrationByUser ($userId: String!) {
    lookupRegistrationByUser(userId: $userId){
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/_app/middleware/lookupRegistrationByUser.query.js